import { useEffect, useRef } from "react";

/**
 * Requests browser Notification permission (once per session) and shows a
 * native OS notification when a new WS message arrives while the tab/document
 * is hidden.
 */
export function useDesktopNotifications({ user, enabled = true }) {
  const permissionAsked = useRef(false);

  useEffect(() => {
    if (!enabled || permissionAsked.current) return;
    if (typeof Notification === "undefined") return;
    if (Notification.permission === "default") {
      // Ask permission on first mount
      Notification.requestPermission().catch(() => {});
    }
    permissionAsked.current = true;
  }, [enabled]);

  return {
    canNotify: () => typeof Notification !== "undefined" && Notification.permission === "granted",
    notify: (title, body) => {
      try {
        if (typeof Notification === "undefined") return;
        if (Notification.permission !== "granted") return;
        if (!document.hidden) return;
        const n = new Notification(title, {
          body,
          icon: "/logo192.png",
          badge: "/logo192.png",
          tag: "yappo-msg",
          silent: false,
        });
        n.onclick = () => {
          window.focus();
          n.close();
        };
        setTimeout(() => { try { n.close(); } catch {} }, 6000);
      } catch {}
    },
  };
}
